import { create } from 'zustand'
import {
    CreateNotificationInAppStore, NotificationInAppAction, NotificationInAppState, NotificationInAppContent,
} from './_types'

const notificationInAppReducer = (state: NotificationInAppState, action: NotificationInAppAction) => {
    switch (action.type) {
        case 'SET_NOTIFICATION':
            return setNotificationInApps(state, action)
        case 'DELETE_NOTIFICATION':
            return deleteNotificationInApp(state, action)
        case 'DISABLE_BADGE_NOTIFICATION':
            return disableBadgeNotificationInApp(state, action)
        default:
            return state
    }
}
const disableBadgeNotificationInApp = (state: NotificationInAppState, action: NotificationInAppAction) => {
    const currentNotifications = state.notifications
    if (currentNotifications[action.source]) currentNotifications[action.source].displayBadge = false
    return {
        notifications: currentNotifications,
    }
}

const deleteNotificationInApp = (state: NotificationInAppState, action: NotificationInAppAction) => {
    const currentNotifications = state.notifications
    delete currentNotifications[action.source]
    return {
        notifications: currentNotifications,
    }
}

const setNotificationInApps = (state: NotificationInAppState, action: NotificationInAppAction) => {
    const currentNotifications = state.notifications

    currentNotifications[action.source] = {
        data: action?.notifications ?? [],
        displayBadge: (action?.notifications?.length ?? 0) > 0,
    }

    return {
        notifications: currentNotifications,
    }
}

export const initNotificationInAppStore = (
    dispatch,
    data: Array<NotificationInAppContent | null>,
    source: string,
): void => {
    dispatch({
        type: 'SET_NOTIFICATION',
        notifications: data,
        source,
    })
}

export const useCreateNotificationInAppStore = create<
    CreateNotificationInAppStore<NotificationInAppState, NotificationInAppAction>
>((set) => ({
    notifications: {},
    dispatch: (action) => set((state) => notificationInAppReducer(state, action)),
}))
